const initialState = {libs: [], libsFetched: false};

export default (state = initialState, action) => {
    switch(action.type) {
        case 'NEWLIBS':
        {

            const oldlibs = state.libs.map(a => ({...a}));
            let newlibs = [];
            if(action.payload.data && action.payload.data.libraries) {
                newlibs = action.payload.data.libraries.map(lib => (
                    {
                        'name': lib.name,
                        'id': lib.id,
                        'ownership': lib.ownership,
                        'library_urn': lib.library_urn
                    }
                ))
            }
            else {
                newlibs = [{
                    'name': action.payload.data.name,
                    'id': action.payload.data.id,
                    'ownership': 'private',
                    'library_urn': action.payload.data.library_urn
                }]
            }
            const combinedlibs = [...oldlibs,...newlibs];
            return {...state,libs: combinedlibs};
        }
        case 'LIBSFETCHED':
        {
            return {...state, libsFetched: true};
        }
        default:
            return state;
    }
}
